// components/exam/ExamCategoryExplorer.jsx
import { ArrowLeft2 } from "iconsax-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { FolderOpen } from "lucide-react";

const ExamCategoryExplorer = ({ path, categories, onSelect, onPathClick }) => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language.includes("fa");

  const ArrowIcon = () => (
    <ArrowLeft2
      size={16}
      className={`inline mx-1 ${isRtl ? "" : "transform rotate-180"}`}
    />
  );
  
  const iconDirectionClass = isRtl ? 'ml-2' : 'mr-2';

  return (
    <div className="mb-8">
      {/* 🧭 Breadcrumb مسیر */}
      <nav
        className={`text-gray-600 mb-6 text-sm font-medium ${
          isRtl ? "text-right" : "text-left"
        }`}
      >
        <span
          onClick={() => onPathClick(-1)}
          className="text-indigo-600 cursor-pointer hover:underline"
        >
          {t("exam_category_explorer.all")}
        </span>

        {path?.length > 0 &&
          path.map((item, i) => (
            <span key={i} className="inline">
              <ArrowIcon />
              <span
                onClick={() => onPathClick(i)}
                className="text-indigo-600 cursor-pointer hover:underline"
              >
                {item.title}
              </span>
            </span>
          ))}
      </nav>

      {/* 🗂️ کارت‌های دسته‌بندی */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {categories.map((cat) => (
          <div
            key={cat._id}
            onClick={() => onSelect(cat)}
            className="bg-white rounded-2xl shadow-md border border-gray-100 hover:shadow-lg transition-all p-5 cursor-pointer flex flex-col justify-between"
          >
          {console.log(cat)}
            {/* آیکون + عنوان */}
            <div className={`flex items-center gap-2  ${isRtl ? 'flex-row' : 'flex-row-reverse'}`}>
              <FolderOpen className={`w-6 h-6 text-purple-600 ${iconDirectionClass}`} />
              <h3 className="text-lg font-bold text-gray-800">{cat.title}</h3>
            </div>

            {/* توضیح دسته‌بندی */}
            {cat.description && (
              <p className="text-sm text-gray-500 mb-2 line-clamp-2">
                {cat.description}
              </p>
            )}

           
          </div>
        ))}
      </div>
    </div>
  );
};

export default ExamCategoryExplorer;